I18n.translations || (I18n.translations = {});
I18n.translations["de"] = I18n.extend((I18n.translations["de"] || {}), {
  "layouts": {
    "header": {
      "about_us": "Über uns",
      "claim": "Deutschlands größte Spendenplattform",
      "discover": "Entdecken",
      "edit_profile_label": "Nutzerprofil bearbeiten",
      "edit_project_label": "Hilfsprojekt bearbeiten",
      "get_started_label": "Spenden sammeln",
      "login": "Anmelden",
      "logo_alt_text": "betterplace.org (Logo)",
      "logout_label": "Abmelden",
      "my_profile": "Mein Profil",
      "new_fundraising_event_label": "Spendenaktion anlegen",
      "new_job_description_label": "Ehrenamtler suchen",
      "new_project_label": "Hilfsprojekt anlegen",
      "profile_label": "Öffentliche Profilseite",
      "search_placeholder": "Suchbegriff eingeben"
    }
  }
});
I18n.translations["en"] = I18n.extend((I18n.translations["en"] || {}), {
  "layouts": {
    "header": {
      "about_us": "About Us",
      "claim": "Change the world with your donation",
      "discover": "Discover",
      "edit_profile_label": "Edit profile",
      "edit_project_label": "Edit project",
      "get_started_label": "Collect donations",
      "login": "Login",
      "logo_alt_text": "betterplace.org (Logo)",
      "logout_label": "Logout",
      "my_profile": "My Profile",
      "new_fundraising_event_label": "Start fundraising event",
      "new_job_description_label": "Create volunteering offer",
      "new_project_label": "Start aid project",
      "profile_label": "Public profile",
      "search_placeholder": "Enter search term"
    }
  }
});
